import { useSelector } from 'react-redux'
import { getString } from '../../../helper/util'
import MUILabel from '../../common/label/MUILabel'


/**
 * Status Label Component
 * @param {React.ReactNode} [icon] - Prefix icon (optional)
 * @param {String} [color] - Color variant: "primary" | "secondary" | "success" | "error" | "info" | "warning" | "default" (optional)
 * @param {String} resource - i18n section name (required)
 * @param {String} keyName - i18n key name (required)
 */
export default function StatusLabel({
    icon,
    color = "primary",
    resource,
    keyName
}) {
    const lang = useSelector((state) => state.lang.ui.lang)
    const theme = useSelector((state) => state.theme.ui.theme)

    const getPresetConfig = (status) => {
        switch (status) {
            case 'A':
                return {
                    color: "success"
                }

            case 'D':
                return {
                    color: "error"
                }

            case 'P':
                return {
                    color: "pending"
                }

            case 'BETA':
                return {
                    color: "grey"
                }

            case 'PILOT':
                return {
                    color: "secondary"
                }

            case 'STABLE':
                return {
                    color: "success"
                }

            case 'DEPRECATED':
                return {
                    color: "error"
                }

            default:
                return {
                    color: "default"
                }
        }
    }

    return <MUILabel {...getPresetConfig(keyName)} variant='ghost' startIcon={icon}>{getString(lang, resource, keyName, theme)}</MUILabel>
}
